import React, { useMemo, useState } from "react";
import {
  FaBoxes,
  FaExclamationTriangle,
  FaCheckCircle,
  FaArrowDown,
  FaSearch,
  FaWarehouse,
  FaClipboardList,
  FaPlus,
} from "react-icons/fa";
import ProcurementStatusTracker from "../ProcurementDashboard/ProcurementStatusTracker";

import ItemSlider from "./ItemSlider";
import InvenKpiAndAlertTable from "./InvenKpiAndAlertTable";
import InventoryTable from "./InventoryTable";

const StoreDashBoard = ({ data }) => {
  // console.log(data);

  // Sample inventory data
  const inventory = [
    {
      id: 1,
      itemCode: "ITM-001",
      itemName: "Bearing 6205",
      category: "Mechanical",
      location: "Store A",
      quantity: 125,
      minStock: 50,
      unit: "Nos",
      status: "In Stock",
    },
    {
      id: 2,
      itemCode: "ITM-002",
      itemName: "Copper Cable 10mm",
      category: "Electrical",
      location: "Store B",
      quantity: 28,
      minStock: 50,
      unit: "Meter",
      status: "Low Stock",
    },
    {
      id: 3,
      itemCode: "ITM-003",
      itemName: "Safety Helmet",
      category: "Safety",
      location: "Store A",
      quantity: 210,
      minStock: 100,
      unit: "Nos",
      status: "In Stock",
    },
    {
      id: 4,
      itemCode: "ITM-004",
      itemName: "Grease EP2",
      category: "Consumable",
      location: "Store C",
      quantity: 12,
      minStock: 25,
      unit: "Kg",
      status: "Low Stock",
    },
    {
      id: 5,
      itemCode: "ITM-005",
      itemName: "LED Tube Light",
      category: "Electrical",
      location: "Store B",
      quantity: 0,
      minStock: 20,
      unit: "Nos",
      status: "Out of Stock",
    },
    {
      id: 6,
      itemCode: "ITM-006",
      itemName: "Steel Nut & Bolt",
      category: "Mechanical",
      location: "Store A",
      quantity: 850,
      minStock: 200,
      unit: "Nos",
      status: "In Stock",
    },
  ];

  return (
    <div className="container-fluid">
      {/* ================= HEADER ================= */}
      <div className="d-flex flex-wrap justify-content-between align-items-center mb-4">
        <div>
          <h4 className="fw-bold mb-1">Inventory Dashboard</h4>

          <p className="text-muted mb-0">
            Monitor stock levels and inventory activity
          </p>
        </div>
      </div>
      <div>
        <ItemSlider data={data} />
      </div>
      {/* <ProcurementStatusTracker /> */}
      {data && <InvenKpiAndAlertTable data={data} station={"DVSN"} />}
      {/* ================= INVENTORY TABLE ================= */}
      <div>
        <InventoryTable data={data} station={"DVSN"} />
      </div>{" "}
    </div>
  );
};

export default StoreDashBoard;
